// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchHeader-searchHeaderContainerBox-f0okF {
    z-index: 6;
    position: relative;
    width: 100%;
}

.SearchHeader-searchHeaderContainer-hVzah {
    width: 100%;
    height: auto;
    position: fixed;
    z-index: 4 !important;
    padding: 0px 33px 0px 33px;
    right: 0;
    left: 0;
    vertical-align: middle;
    top: 82px;
    border-top: 1px solid var(--primary-border);
    border-bottom: 1px solid var(--primary-border);
    background: var(--background-primary);
}

.SearchHeader-filterButtonContainer-RRuMK {
    position: relative;
    padding: 21px 0px;
}

.SearchHeader-filterBtn-OAnv1,
.SearchHeader-filterBtn-OAnv1:active,
.SearchHeader-filterBtn-OAnv1:focus {
    padding: 13px 18px !important;
    border-radius: 27px !important;
    background: var(--primary-color) !important;
    color: var(--white-color) !important;
    border: 1px solid var(--primary-color) !important;
    -webkit-box-shadow: none !important;
            box-shadow: none !important;
    font-size:20px;
    font-weight: normal;
}

.SearchHeader-filterBtn-OAnv1:hover,
.SearchHeader-filterBtn-OAnv1.SearchHeader-filterBtnIsActive-mOueA {
    background: var(--primary-color) !important;
    color: var(--white-color) !important;
    border-color: var(--primary-color) !important;
}

.SearchHeader-filterRow-pKXql {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
}

.SearchHeader-btnFlex-XgAHP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.SearchHeader-filterBtn-OAnv1 img {
    -webkit-filter: brightness(0) invert(1);
            filter: brightness(0) invert(1);
}

.SearchHeader-divider-f9Maj {
    width: 3px;
    height: 50px;
    background-color: var(--primary-color);
}

.SearchHeader-chipsWrapper-cw_4a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px;
    overflow-x: auto;
    padding: 16px 0;
}

.SearchHeader-lupaCharacter-IOa27 {
    width: 89px;
    height: 59px;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.SearchHeader-mobileSearchHeader-ps4KT {
    display: grid;
    grid-template-columns: auto 51px;
    gap: 10px;
}

@media screen and (max-width: 768px) {
    .SearchHeader-fullResponsiveContainer-U4mwC {
        z-index: 80;
        height: 100%;
    }
}

@media screen and (max-width:767px) {
    .SearchHeader-searchHeaderResponsive-giGdE {
        width: 100%;
        height: 100%;
        position: relative;
        min-width: 350px;
    }

    .SearchHeader-searchHeaderContainer-hVzah {
        top: 82px;
        padding: 18px 24px 0 24px;
    }

    .SearchHeader-modileFilterSection-XoMXi {
        display: grid;
        grid-template-columns: auto 51px;
        gap: 8px;
    }

    .SearchHeader-filterBtn-OAnv1,
    .SearchHeader-filterBtn-OAnv1:active,
    .SearchHeader-filterBtn-OAnv1:hover,
    .SearchHeader-filterBtn-OAnv1:focus {
        padding: 16px !important;
    }

    .SearchHeader-searchHeaderContainer-hVzah::after {
        content: '';
        width: 100%;
        height: 1px;
        background-color: var(--primary-border);
        position: absolute;
        top: 87px;
        left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/SearchHeader/SearchHeader.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,0BAA0B;IAC1B,QAAQ;IACR,OAAO;IACP,sBAAsB;IACtB,SAAS;IACT,2CAA2C;IAC3C,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;;IAGI,6BAA6B;IAC7B,8BAA8B;IAC9B,2CAA2C;IAC3C,oCAAoC;IACpC,iDAAiD;IACjD,mCAA2B;YAA3B,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,2CAA2C;IAC3C,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,uCAA+B;YAA/B,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,QAAQ;IACZ;;IAEA;;;;QAII,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,WAAW;QACX,WAAW;QACX,uCAAuC;QACvC,kBAAkB;QAClB,SAAS;QACT,OAAO;IACX;AACJ","sourcesContent":[".searchHeaderContainerBox {\n    z-index: 6;\n    position: relative;\n    width: 100%;\n}\n\n.searchHeaderContainer {\n    width: 100%;\n    height: auto;\n    position: fixed;\n    z-index: 4 !important;\n    padding: 0px 33px 0px 33px;\n    right: 0;\n    left: 0;\n    vertical-align: middle;\n    top: 82px;\n    border-top: 1px solid var(--primary-border);\n    border-bottom: 1px solid var(--primary-border);\n    background: var(--background-primary);\n}\n\n.filterButtonContainer {\n    position: relative;\n    padding: 21px 0px;\n}\n\n.filterBtn,\n.filterBtn:active,\n.filterBtn:focus {\n    padding: 13px 18px !important;\n    border-radius: 27px !important;\n    background: var(--primary-color) !important;\n    color: var(--white-color) !important;\n    border: 1px solid var(--primary-color) !important;\n    box-shadow: none !important;\n    font-size:20px;\n    font-weight: normal;\n}\n\n.filterBtn:hover,\n.filterBtn.filterBtnIsActive {\n    background: var(--primary-color) !important;\n    color: var(--white-color) !important;\n    border-color: var(--primary-color) !important;\n}\n\n.filterRow {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.btnFlex {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n}\n\n.filterBtn img {\n    filter: brightness(0) invert(1);\n}\n\n.divider {\n    width: 3px;\n    height: 50px;\n    background-color: var(--primary-color);\n}\n\n.chipsWrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    overflow-x: auto;\n    padding: 16px 0;\n}\n\n.lupaCharacter {\n    width: 89px;\n    height: 59px;\n    flex-shrink: 0;\n}\n\n.mobileSearchHeader {\n    display: grid;\n    grid-template-columns: auto 51px;\n    gap: 10px;\n}\n\n@media screen and (max-width: 768px) {\n    .fullResponsiveContainer {\n        z-index: 80;\n        height: 100%;\n    }\n}\n\n@media screen and (max-width:767px) {\n    .searchHeaderResponsive {\n        width: 100%;\n        height: 100%;\n        position: relative;\n        min-width: 350px;\n    }\n\n    .searchHeaderContainer {\n        top: 82px;\n        padding: 18px 24px 0 24px;\n    }\n\n    .modileFilterSection {\n        display: grid;\n        grid-template-columns: auto 51px;\n        gap: 8px;\n    }\n\n    .filterBtn,\n    .filterBtn:active,\n    .filterBtn:hover,\n    .filterBtn:focus {\n        padding: 16px !important;\n    }\n\n    .searchHeaderContainer::after {\n        content: '';\n        width: 100%;\n        height: 1px;\n        background-color: var(--primary-border);\n        position: absolute;\n        top: 87px;\n        left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchHeaderContainerBox": `SearchHeader-searchHeaderContainerBox-f0okF`,
	"searchHeaderContainer": `SearchHeader-searchHeaderContainer-hVzah`,
	"filterButtonContainer": `SearchHeader-filterButtonContainer-RRuMK`,
	"filterBtn": `SearchHeader-filterBtn-OAnv1`,
	"filterBtnIsActive": `SearchHeader-filterBtnIsActive-mOueA`,
	"filterRow": `SearchHeader-filterRow-pKXql`,
	"btnFlex": `SearchHeader-btnFlex-XgAHP`,
	"divider": `SearchHeader-divider-f9Maj`,
	"chipsWrapper": `SearchHeader-chipsWrapper-cw_4a`,
	"lupaCharacter": `SearchHeader-lupaCharacter-IOa27`,
	"mobileSearchHeader": `SearchHeader-mobileSearchHeader-ps4KT`,
	"fullResponsiveContainer": `SearchHeader-fullResponsiveContainer-U4mwC`,
	"searchHeaderResponsive": `SearchHeader-searchHeaderResponsive-giGdE`,
	"modileFilterSection": `SearchHeader-modileFilterSection-XoMXi`
};
module.exports = ___CSS_LOADER_EXPORT___;
